(function () {
  var STAGGER = 0.12;
  var ENTRANCE_DURATION = 900;
  var COUNTER_DURATION = 1800;
  var ENTRANCE_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function parseStatValue(raw) {
    var value = String(raw || '').trim();
    var match = value.match(/^([^0-9.-]*)([\d.]+)(.*)$/);

    if (!match) {
      return { prefix: '', target: 0, suffix: value, decimals: 0, static: true };
    }

    var numStr = match[2];
    var decimals = (numStr.split('.')[1] || '').length;

    return {
      prefix: match[1],
      target: parseFloat(numStr),
      suffix: match[3],
      decimals: decimals,
      static: false
    };
  }

  function formatStatValue(current, parsed) {
    var value = parsed.decimals > 0 ? current.toFixed(parsed.decimals) : String(Math.round(current));
    return parsed.prefix + value + parsed.suffix;
  }

  function animateEntrance(items, startDelay) {
    items.forEach(function (item, index) {
      var delay = startDelay + index * STAGGER * 1000;

      item.animate(
        [
          { opacity: 0, transform: 'translateY(2rem)' },
          { opacity: 1, transform: 'translateY(0)' }
        ],
        {
          duration: ENTRANCE_DURATION,
          delay: delay,
          easing: ENTRANCE_EASING,
          fill: 'forwards'
        }
      );
    });
  }

  function animateCounter(element, rawValue, delay) {
    var parsed = parseStatValue(rawValue);

    if (parsed.static || Number.isNaN(parsed.target)) {
      element.textContent = rawValue;
      return;
    }

    var startTime = null;

    function tick(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / COUNTER_DURATION, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = parsed.target * eased;

      element.textContent = formatStatValue(current, parsed);

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        element.textContent = formatStatValue(parsed.target, parsed);
      }
    }

    element.textContent = formatStatValue(0, parsed);

    window.setTimeout(function () {
      requestAnimationFrame(tick);
    }, delay);
  }

  function isVisible(element) {
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function initHero(section) {
    if (!section || section.dataset.rngHeroInit === 'true') return;
    section.dataset.rngHeroInit = 'true';

    var items = Array.prototype.slice.call(section.querySelectorAll('[data-rng-hero-item]'));
    var counters = Array.prototype.slice.call(section.querySelectorAll('[data-rng-hero-stat-value]')).filter(isVisible);

    items.forEach(function (item) {
      item.style.opacity = '0';
      item.style.transform = 'translateY(2rem)';
    });

    if (prefersReducedMotion()) {
      items.forEach(function (item) {
        item.style.opacity = '1';
        item.style.transform = 'none';
      });

      counters.forEach(function (counter) {
        counter.textContent = counter.getAttribute('data-rng-hero-stat-value') || counter.textContent;
      });

      return;
    }

    animateEntrance(items, 200);

    counters.forEach(function (counter, index) {
      var rawValue = counter.getAttribute('data-rng-hero-stat-value') || counter.textContent;
      var counterDelay = 700 + index * 180;
      animateCounter(counter, rawValue, counterDelay);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-rng-hero]').forEach(initHero);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-rng-hero]') || event.target.closest('[data-rng-hero]');
    if (section) {
      section.dataset.rngHeroInit = 'false';
      initHero(section);
    }
  });
})();
